import * as exBootstrap from '../../bootstrap';

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Collapse', element, config);
}

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.hide('Collapse', element, config);
}

function toggle(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.toggle('Collapse', element, config);
}

// ----------------------------------------------------------------------------

export { show, hide, toggle };
